<template>
  <div class="quiz-viewer">
    <div class="has-text-centered" v-if="IsLoading || isDeleting">
      <button
        disabled="disabled"
        class="button is-loading is-disabled is-white"
      >
        ...
      </button>
    </div>
    <div v-else>
      <div
        class="is-pulled-right control has-addons"
          v-if="quizes.length > 0"
          style="margin-right: 5px"
        >
          <router-link
            tag="button"
            :to="`/${$route.params.lang}/places/${quizes[0].placeId}/quiz/${quizes[0].id}/edit?lang=${quizes[0].language}`"
            class="button is-primary is-small"
            v-if="CanBeEdited && quizes[0].language === 'pt'"
          >
            Editar Desafio
          </router-link>
          <button
            v-else-if="CanBeEdited"
            class="button is-primary is-small"
            @click="editQuiz(quizes[0])"
          >
            Editar Tradução
          </button>
          <pop-confirm
            content="Você tem certeza?"
            :show-cancel="false"
            :on-ok="() => {
              if (quizes[0].language === 'pt') {
                DelQuiz(quizes[0])
              } else {
                DelQuizTranslation()
              }
            }"
            v-if="CanBeDeleted"
          >
            <button
              class="button is-danger is-small"
            >
              {{ quizes[0].language === 'pt' ? 'Apagar Desafio' : 'Apagar Tradução' }}
            </button>
          </pop-confirm>
      </div>
      <p v-else class="has-text-centered">
        <slot name="empty-quizes">Nenhum Desafio encontrado.</slot>
      </p>
      <div v-for="quiz in quizes" :key="quiz.id">
        <div class="field">
          <h5 class="title is-5">Título</h5>
          <div class="control">
            {{quiz.title}}
          </div>
        </div>
        <div class="field">
          <h5 class="title is-5">Descrição</h5>
          <div class="control">
            {{quiz.description}}
          </div>
        </div>
        <div class="field" v-if="quiz.answers" style="padding: 0 5px 5px 5px">
          <collapse accordion>
            <collapse-item title="Respostas">
              <answer-viewer
                v-for="a in quiz.answers"
                :key="a.id"
                :answer="a"
                :can-be-deleted="a.language !== 'pt' && CanBeDeleted"
              />
            </collapse-item>
          </collapse>
        </div>
      </div>
    </div>
    <modal
      title="Atualizar Tradução do Desafio"
      :width="1000"
      :is-show="quizTranslateModal"
      transition="fadeDown"
      :show-ok="false"
      :show-cancel="false"
      @close="quizTranslateModal=false"
    >
      <quiz-translate-updater :quiz="quizToUpdate" />
    </modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AnswerViewer from './QuizAnswerViewer'
import QuizTranslateUpdater from './QuizTranslateUpdater'

export default {
  name: 'QuizViewer',
  components: { AnswerViewer, QuizTranslateUpdater },
  props: {
    IsLoading: {
      type: Boolean,
      default: false
    },
    quizes: {
      type: [Array],
      required: true,
      default: () => []
    },
    CanBeEdited: {
      type: Boolean,
      default: false
    },
    CanBeDeleted: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isDeleting: false,
      quizTranslateModal: false,
      quizToUpdate: {}
    }
  },
  methods: {
    ...mapActions(['DeleteQuiz', 'deleteQuizTranslation']),
    DelQuiz (quiz) {
      this.isDeleting = true
      this.DeleteQuiz(
        {
          placeId: this.quizes[0].placeId,
          quiz
        }
      )
        .then(
          success => {
            this.isDeleting = false
            this.$notify.open({
              type: 'success',
              content: 'O Desafio foi apagado com sucesso.',
              duration: 10000
            })
          },
          error => {
            console.log(error.response)
            this.isDeleting = false
            this.$notify.open({
              type: 'danger',
              content: 'Não foi possível apagar o Desafio no momento.',
              duration: 10000
            })
          }
        )
    },
    async DelQuizTranslation () {
      const placeId = this.$route.params.id
      const { language } = this.quizes[0]
      const id = this.quizes[0].languageId || this.quizes[0].id
      const quizId = this.quizes[0].quizId || this.quizes[0].id
      try {
        this.isDeleting = true
        await this.deleteQuizTranslation({ placeId, quizId, id, language })
        this.isDeleting = false
        this.$notify.open({
          type: 'success',
          content: 'Tradução do Desafio foi apagada com sucesso.',
          duration: 10000
        })
      } catch (error) {
        console.log(error)
        console.log(error.response)
        this.isDeleting = false
        this.$notify.open({
          type: 'danger',
          content: 'Não foi possível apagar a Tradução do Desafio no momento.',
          duration: 10000
        })
      }
    },
    editQuiz (quiz) {
      this.quizTranslateModal = true
      this.quizToUpdate = quiz
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/QuizViewer.vue